/**
 * Builds one export file from a job (ADR 0018). Runs inside the export Web Worker, or on the page when no
 * worker is available (tests, very old browsers); the CSV/XLSX builders yield between chunks there.
 */
import { buildCsv } from "./csv";
import { buildPdf } from "./pdf";
import { MIME, type ExportJob } from "./sheet";
import { buildXlsx } from "./xlsx";

export async function buildFile(job: ExportJob): Promise<{ data: ArrayBuffer | string; mime: string }> {
  if (job.format === "csv") return { data: await buildCsv(job.sheets[0]!, job.meta, job.separator ?? ","), mime: MIME.csv };
  if (job.format === "xlsx") return { data: await buildXlsx(job.sheets, job.meta), mime: MIME.xlsx };
  if (!job.fonts) throw new Error("pdf fonts missing");
  const bytes = await buildPdf(job.sheets, job.meta, job.fonts, job.mapImage);
  return { data: bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength) as ArrayBuffer, mime: MIME.pdf };
}
